import React, {useContext, useEffect, useState} from 'react'
import {
  InputConResultado,
  ListaDesplegable,
  ListaDesplegableConSelector,
  ListaDesplegableConResultado,
} from '../inputs'
import {BotonSimple} from '../Botones'
import {ContextoRecargarSaldo, ContextoAplicacion} from '../../contexto'
import {ObtenerEmpresaPorId} from '../../microservicios'
import {useForm, Controller} from 'react-hook-form'
import {ObtenerTodasLasCiudades} from '../../cache/servicios-cache'
import {ContenedorTituloResaltado} from '../Contenedores'
import {aplicarFormatoMoneda} from '../../utils'
import {AlertaDinamica} from '../MostrarEnPantalla'
import clsx from 'clsx'
import {
  OPCIONES_RETENCIONES_RENTA,
  OPCIONES_SOBRETASA_BOMBERIL,
  OPCIONES_RETENCIONES_IVA,
} from '../../constantes'
import {ObtenerConfiguracionPorParticion} from '../../microservicios'
import {removerAcentos} from '../../utils'

const OtrosServiciosRecargarCuentaServicios = ({
  manejarGuardar,
  datosTransaccion,
  datosServicio,
  datosTiquetera,
  datosSede,
  funcionRegresar,
}) => {
  const contextoRecargarSaldo = useContext(ContextoRecargarSaldo)

  const contextoAplicacion = useContext(ContextoAplicacion)

  const valoresTablaPorDefecto = {
    montoRecarga: '',
    retencionRenta: '',
    rentaTotal: '',
    retencionICA: '',
    ICATotal: '',
    sobretasaBomberil: '',
    bomberilTotal: '',
    retencionIVA: '',
    totalIVA: '',
    valorRecibido: '',
  }
  const [valoresTabla, setValoresTabla] = useState(valoresTablaPorDefecto)
  const [alertaICA, setAlertaICA] = useState(false)
  const [totalTabla, setTotalTabla] = useState(0)
  const [municipio, setMunicipio] = useState({})
  const [aplicaRetenciones, setAplicaRetenciones] = useState('0') //VALOR POR DEFECTO "" (string vacío), se cambio a "0" PARA NO USAR RETENCIONES
  const [municipiosSedesCendiatra, setMunicipiosSedesCendiatra] = useState([
    {
      Id: 1,
      Nombre: 'No aplica',
      Tarifa: 0,
    },
  ])

  const idEmpresa = contextoAplicacion.infoEmpresa.id ?? 0

  const {
    trigger,
    control,
    setValue,
    clearErrors,
    setError,
    formState: {errors},
  } = useForm({
    mode: 'onChange',
  })

  useEffect(() => {
    const cargarinformacionInicial = async () => {
      try {
        const datosCuentasMunicipios = await ObtenerConfiguracionPorParticion(
          'TarifasRetenciones'
        )
        const todasLasCiudades = await ObtenerTodasLasCiudades()
        const municipiosParaMostrar = datosCuentasMunicipios.data.map(
          (municipio) => {
            return {
              Id: municipio.cuenta,
              Nombre: municipio.municipio,
              Tarifa: municipio.tarifa,
              MunicipioId: todasLasCiudades.find((ciudad) => {
                let nombreMunicipio = municipio.municipio.trim()
                if (nombreMunicipio.startsWith('IBAGUE')) {
                  nombreMunicipio = nombreMunicipio.split(' ')[0]
                }
                return (
                  removerAcentos(ciudad.Nombre) ===
                  removerAcentos(nombreMunicipio)
                )
              })?.Id,
            }
          }
        )
        setMunicipiosSedesCendiatra((prev) => [
          ...prev,
          ...municipiosParaMostrar,
        ])
      } catch (error) {
        console.log(error)
      }
    }
    if (idEmpresa) {
      cargarinformacionInicial()
      obtenerDatosEmpresa()
    }
  }, [idEmpresa])

  useEffect(() => {
    const valor = Number(aplicaRetenciones)
    if (!valor) {
      setValoresTabla((prev) => ({
        ...valoresTablaPorDefecto,
        montoRecarga: prev.montoRecarga,
      }))
      setMunicipio({})
      setValue('municipio', '')
    }
    trigger()
  }, [aplicaRetenciones])

  const obtenerDatosEmpresa = async () => {
    ObtenerEmpresaPorId(idEmpresa).then((res) => {
      contextoRecargarSaldo.setFormularioRecargarSaldo({
        ...contextoRecargarSaldo.formularioRecargarSaldo,
        identificacionCliente: res?.data?.nit,
      })
      contextoRecargarSaldo.setDataPdf({
        documento: res?.data?.nit,
        nombre: res?.data?.nombre,
        direccion: res?.data?.direccion,
        telefono: res?.data?.telefono,
      })
    })
  }

  const calcularRetencionRenta = (valor) => {
    if (valor && parseInt(datosTransaccion?.totalServicios)) {
      const total = (parseInt(datosTransaccion?.totalServicios) * valor) / 100
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: isNaN(total) ? '' : total,
        }
      })
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: '',
        }
      })
    }
  }

  const calcularRetencionICA = (valor) => {
    if (valor && parseInt(datosTransaccion?.totalServicios)) {
      const total = (parseInt(datosTransaccion?.totalServicios) * valor) / 1000
      setValoresTabla((prev) => {
        return {
          ...prev,
          ICATotal: isNaN(total) ? '' : total,
        }
      })
      setAlertaICA(false)
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          ICATotal: '',
          bomberilTotal: '',
        }
      })
    }
  }

  const calcularSobretasaBomberil = (valor) => {
    if (!valoresTabla?.ICATotal && valor) {
      return setAlertaICA(true)
    }
    if (valor && parseInt(datosTransaccion?.totalServicios)) {
      const total = (valoresTabla?.ICATotal * valor) / 100
      setValoresTabla((prev) => {
        return {
          ...prev,
          bomberilTotal: isNaN(total) || !valoresTabla?.ICATotal ? '' : total,
        }
      })
      setAlertaICA(false)
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          bomberilTotal: '',
        }
      })
      setAlertaICA(false)
    }
  }

  const calcularRetencionIVA = (valor) => {
    if (valor && parseInt(datosTransaccion?.totalIva)) {
      const total = (parseInt(datosTransaccion?.totalIva) * valor) / 100
      setValoresTabla((prev) => {
        return {
          ...prev,
          totalIVA: isNaN(total) ? '' : total,
        }
      })
    } else if (!valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          totalIVA: '',
        }
      })
    }
  }
  const calcularValoresEnTabla = (nombrePropiedad, valor) => {
    const funcionesPorPropiedad = {
      retencionRenta: () => calcularRetencionRenta(valor),
      retencionICA: () => calcularRetencionICA(valor),
      sobretasaBomberil: () => calcularSobretasaBomberil(valor),
      retencionIVA: () => calcularRetencionIVA(valor),
    }
    if (nombrePropiedad in funcionesPorPropiedad) {
      funcionesPorPropiedad[nombrePropiedad]()
    }
  }
  const modificarValoresTabla = (nombrePropiedad, valor) => {
    setValoresTabla((prev) => {
      return {
        ...prev,
        [nombrePropiedad]: valor ?? '',
      }
    })
    calcularValoresEnTabla(nombrePropiedad, valor)
    if (nombrePropiedad === 'montoRecarga' && !valor) {
      setValoresTabla((prev) => {
        return {
          ...prev,
          rentaTotal: '',
          ICATotal: '',
          bomberilTotal: '',
        }
      })
    }
  }
  useEffect(() => {
    const calcularValorTotal = () => {
      const valoresNumericos = [
        parseInt(datosTransaccion?.totalTransaccion),
        valoresTabla?.rentaTotal,
        valoresTabla?.ICATotal,
        valoresTabla?.bomberilTotal,
        valoresTabla?.totalIVA,
      ]
        .filter((valor) => valor !== '')
        .map((valor) => parseFloat(valor))
      if (valoresNumericos.length >= 1) {
        const resultado = valoresNumericos
          .slice(1)
          .reduce(
            (acumulador, valor) => acumulador - valor,
            valoresNumericos[0]
          )

        setValoresTabla((prev) => {
          return {
            ...prev,
            valorRecibido:
              parseFloat(resultado) +
                (parseFloat(datosTransaccion.totalTransaccion) ?? 0),
          }
        })

        return setTotalTabla(resultado)
      } else {
        return setTotalTabla(0)
      }
    }
    calcularValorTotal()
  }, [
    parseInt(datosTransaccion?.totalServicios),
    valoresTabla?.rentaTotal,
    valoresTabla?.ICATotal,
    valoresTabla?.bomberilTotal,
    valoresTabla?.totalIVA,
  ])

  useEffect(() => {
    calcularRetencionRenta(valoresTabla?.retencionRenta)
    calcularRetencionICA(valoresTabla?.retencionICA)
    calcularSobretasaBomberil(valoresTabla?.sobretasaBomberil)
    calcularRetencionIVA(valoresTabla?.retencionIVA)
  }, [parseInt(datosTransaccion?.totalServicios), valoresTabla?.ICATotal])

  const manejarMunicipioSeleccionado = (municipio) => {
    if (municipio) {
      modificarValoresTabla('retencionICA', municipio.Tarifa)
      setValue('municipio', municipio.Nombre)
      clearErrors('municipio')
      setMunicipio(municipio)
    } else {
      modificarValoresTabla('sobretasaBomberil', '')
      modificarValoresTabla('retencionICA', '')
      setError('municipio', {type: 'require', message: ''})
      setValue('municipio', '')
      setMunicipio('')
    }
    if (!municipio?.Tarifa) {
      modificarValoresTabla('sobretasaBomberil', '')
      modificarValoresTabla('retencionICA', '')
    }
  }

  return (
    <>
      <div className="w-full flex justify-center items-center flex-wrap ">
        <div className="w-11/12 flex justify-end items-center my-2 p-5">
          <div className="w-full flex justify-start items-center flex-wrap -mt-14">
            <div className="w-full flex justify-start">
              <span className="w-1/12 text-cendiatra items-center justify-center text-lg font-bold">
                Servicios{' '}
              </span>
              <span className="w-2/12 text-cendiatra items-center justify-center text-lg font-bold ml-3 text-end">
                {aplicarFormatoMoneda(datosTransaccion?.totalServicios)}
              </span>
            </div>
            <div className="w-full flex justify-start">
              <span className="w-1/12 text-cendiatra items-center justify-center text-lg font-bold">
                IVA 19%
              </span>
              <span className="w-2/12 text-cendiatra items-center justify-center text-lg font-bold ml-3 text-end">
                {aplicarFormatoMoneda(datosTransaccion?.totalIva)}
              </span>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center items-center flex-wrap ">
          <div className="w-11/12 flex justify-end items-center -mt-5 p-5">
            <div className="w-5/12 flex justify-end items-center">
              <span className="w-8/12 text-cendiatra-verde-3 font-bold text-2xl text-right pr-5">
                Monto a pagar
              </span>
              <span className="w-7/12 flex  items-center text-cendiatra-verde-3 text-2xl font-bold">
                {aplicarFormatoMoneda(datosTransaccion.totalTransaccion)}
              </span>
            </div>
          </div>
          {/* <div className="w-11/12 flex justify-center items-center mt-10">
            <div className="w-full flex justify-center items-center border-2 border-cendiatra-gris-2 rounded-2xl p-5 my-2">
              <span className="w-6/12 text-cendiatra-gris-1 mr-3 text-lg">
                ¿Aplica retenciones?
              </span>
              <div className="w-6/12 flex flex-wrap justify-end items-center">
                <ListaDesplegable
                  onChange={(e) => setAplicaRetenciones(e.target.value)}
                  estilosContenedor={'w-7/12'}
                  estilosLista={clsx(
                    'appearance-none rounded relative block w-full p-1.5 border text-cendiatra-gris-3 rounded-lg focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                    {
                      'border-cendiatra-rojo-1': !aplicaRetenciones,
                      'border-cendiatra focus:border-cendiatra':
                        aplicaRetenciones,
                    }
                  )}
                  titulo={''}
                  opciones={[
                    {Id: 0, Nombre: 'No'},
                    {Id: 1, Nombre: 'Sí'},
                  ]}
                  valor={aplicaRetenciones}
                />
              </div>
            </div>
          </div> */}
          {/* CODIGO COMENTADO POR CAMBIO EN RETENCIONES */}
        </div>
        {+aplicaRetenciones ? (
          <>
            <div className="w-full flex justify-center items-center my-2 flex-wrap">
              <div className="w-11/12 flex justify-end items-center my-2">
                <AlertaDinamica
                  mostrarAlerta={true}
                  mensaje={
                    'Recuerde si aplica retenciones, estas deben de estar debidamente certificadas y enviadas al correo electrónico impuestos@cendiatra.com'
                  }
                  estilosTexto={'w-full font-bold text-lg'}
                  color={'text-cendiatra-rojo-2'}
                />
              </div>
            </div>

            <div className="w-11/12 flex justify-center items-center flex-wrap py-2 text-cendiatra font-bold">
              <ContenedorTituloResaltado
                titulo={'TARIFAS DE RETENCIÓN'}
                margenContenedor={'mb-20 border-none'}
                paddingContenedor={
                  'w-full flex justify-center items-center flex-wrap '
                }
              >
                {' '}
                <span className="w-8/12 mt-3 text-center text-cendiatra-rojo-1 text-xl font-semibold">
                  Es responsabilidad del cliente conocer e ingresar sus tarifas
                  de retención.
                </span>
                <span className="w-8/12  text-center text-cendiatra-rojo-1 text-xl font-semibold">
                  Recuerde que las retenciones se deben realizar con cada pago.
                  (Art. 392 ET).
                </span>
                <span className="w-8/12 mb-3 text-center text-cendiatra-rojo-1 text-xl font-semibold">
                  Por favor, asesórese para diligenciar correctamente esta
                  información.
                </span>
                <span className="w-8/12 mt-5 text-center text-cendiatra-gris-1 text-xl ">
                  No olvide que la base para practicar la retención en la
                  fuente, inicia a partir de
                </span>
                <span className="w-8/12  text-center text-cendiatra-gris-1 text-xl mb-5">
                  4 UVT ($ 199.000 COP año 2025)
                </span>
                <div className="w-11/12 flex justify-center items-center mb-2">
                  <ListaDesplegableConResultado
                    titulo={
                      'Tarifa de retención de Renta (% sobre valor de recarga)'
                    }
                    estilosTitulo={'text-lg'}
                    estilosInput={`appearance-none rounded relative block w-full p-1.5 border border-cendiatra rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm 
                ${
                  aplicaRetenciones
                    ? 'text-cendiatra-verde-3 font-bold text-center text-2xl'
                    : 'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white'
                }
                
                `}
                    opciones={OPCIONES_RETENCIONES_RENTA}
                    valor={valoresTabla.retencionRenta}
                    funcion={(e) =>
                      modificarValoresTabla('retencionRenta', e.target.value)
                    }
                    totalCalculado={valoresTabla.rentaTotal}
                    colorTexto={'text-cendiatra-verde-3'}
                    opcionPorDefecto={'0.00%'}
                  />
                </div>
                <div className="w-full flex justify-center items-center flex-wrap border-2 rounded-lg py-5 my-2">
                  <div className="w-11/12 flex justify-end items-center border border-cendiatra-gris-2 rounded-3xl p-5 mb-5">
                    <span className="w-7/12  text-cendiatra-gris-2 mr-3 text-lg font-bold">
                      *Comience a escribir el municipio desde donde está
                      haciendo la recarga y al obtener resultados selecciónelo
                      de la lista desplegable.
                    </span>
                    <div className="w-5/12 flex flex-wrap justify-end items-center">
                      <span className="w-5/12 text-cendiatra-verde-3 font-bold text-lg text-right pr-5">
                        Municipio*
                      </span>
                      <Controller
                        name="municipio"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({fieldState: {error}}) => (
                          <ListaDesplegableConSelector
                            titulo={''}
                            estilosPersonalizados={'w-7/12'}
                            estilosInput={clsx(
                              'appearance-none rounded relative block w-full text-center p-1.5 border rounded-lg focus:outline-none focus:ring-indigo-500 focus:z-10 sm:text-sm',
                              {
                                'border-cendiatra-rojo-1': error,
                                'border-cendiatra': !error,
                              }
                            )}
                            textoPorDefecto={'ELEGIR'}
                            placeholder={'Ciudad'}
                            datosParaMostrar={municipiosSedesCendiatra}
                            manejarOpcionSeleccionada={
                              manejarMunicipioSeleccionado
                            }
                            textoToolTip={''}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="w-11/12 flex justify-center items-center mb-5">
                    <InputConResultado
                      titulo={
                        'Tarifa de retención ICA (valor de los servicios * tarifa / 1000)'
                      }
                      estilosInput={`appearance-none rounded relative block w-full text-center p-1.5 border border-cendiatra  rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white`}
                      placeholder={'0,00'}
                      valor={valoresTabla.retencionICA}
                      funcion={(e) =>
                        modificarValoresTabla('retencionICA', e.floatValue)
                      }
                      totalCalculado={valoresTabla.ICATotal}
                      descripcion={
                        'Res. DDI-023769 Grandes contribuyentes Bogotá.'
                      }
                      porcentaje={false}
                      prefix={''}
                      isAllowed={(values) => {
                        return (values?.floatValue ?? 0) <= 10
                      }}
                    />
                  </div>
                  <div className="w-11/12 flex justify-center items-center mb-2 flex-wrap">
                    <ListaDesplegableConResultado
                      estilosTitulo={'text-lg'}
                      titulo={'Sobretasa Bomberil (% sobre el valor del ICA)'}
                      estilosInput={clsx(
                        'appearance-none rounded relative block w-full text-center p-1.5 border border-cendiatra rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm',
                        {
                          'text-cendiatra-verde-3 font-bold text-center':
                            !Object.keys(errors).includes('municipio') &&
                            municipio.Tarifa,
                          'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white':
                            Object.keys(errors).includes('municipio') ||
                            !municipio.Tarifa,
                        }
                      )}
                      opciones={OPCIONES_SOBRETASA_BOMBERIL}
                      valor={valoresTabla.sobretasaBomberil}
                      funcion={(e) =>
                        modificarValoresTabla(
                          'sobretasaBomberil',
                          e.target.value
                        )
                      }
                      totalCalculado={valoresTabla.bomberilTotal}
                      colorTexto={'text-cendiatra-verde-3'}
                      opcionPorDefecto={'0.00%'}
                    />
                    <span className="w-full text-cendiatra-gris-1 font-bold ml-2 -mt-2 text-lg">
                      Recuerde si aplica la sobre tasa Bomberil debe seleccionar
                      el porcentaje
                    </span>
                  </div>
                  <div className="w-full flex justify-start items-center">
                    <div className="w-6/12"></div>
                    <div className="w-5/12">
                      <AlertaDinamica
                        mostrarAlerta={alertaICA}
                        mensaje={
                          'Se requiere la tarifa ICA para calcular Bomberil'
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full flex justify-center items-center ml-2 my-2 border-b-2 pb-5">
                  <div className="w-11/12 flex justify-center items-center flex-wrap">
                    <ListaDesplegableConResultado
                      estilosTitulo={'text-lg '}
                      titulo={
                        'Tarifa retención de IVA (% sobre el valor del IVA)'
                      }
                      estilosInput={clsx(
                        'appearance-none rounded relative block w-full p-1.5 border border-cendiatra rounded-lg focus:outline-none focus:ring-indigo-500 focus:border-cendiatra focus:z-10 sm:text-sm',
                        {
                          'text-cendiatra-verde-3 font-bold text-center text-2xl':
                            aplicaRetenciones,
                          'bg-cendiatra-gris-placeholder pointer-events-none text-white placeholder-white':
                            !aplicaRetenciones,
                        }
                      )}
                      opciones={OPCIONES_RETENCIONES_IVA}
                      valor={valoresTabla.tarifaIVA}
                      funcion={(e) =>
                        modificarValoresTabla('retencionIVA', e.target.value)
                      }
                      totalCalculado={valoresTabla.totalIVA}
                      colorTexto={'text-cendiatra-verde-3'}
                      opcionPorDefecto={'0.00%'}
                    />
                  </div>
                </div>
                <div className="w-full flex justify-end items-center my-2">
                  <div className="w-3/12 flex justify-center ">
                    <span className=" text-cendiatra-verde-2 font-bold text-start text-2xl">
                      Total a pagar
                    </span>
                  </div>
                  <div className="w-3/12 flex justify-center">
                    <span className="text-cendiatra-verde-2 font-bold text-center text-2xl">
                      {aplicarFormatoMoneda(totalTabla)}
                    </span>
                  </div>
                </div>
                <div className="w-full flex justify-center items-center mb-2 mt-10">
                  <span className=" text-cendiatra-gris-2 font-bold text-start text-lg">
                    Cendiatra no asume la responsabilidad de errores en la
                    información proporcionada por el cliente.
                  </span>
                </div>
              </ContenedorTituloResaltado>
            </div>
          </>
        ) : (
          <div className="w-full flex flex-wrap justify-end items-center mt-10 mb-16">
            {/* <div className="w-3/12 flex justify-center ">
              <span className=" text-cendiatra-verde-2 font-bold text-start text-2xl">
                Valor a recibir
              </span>
            </div>
            <div className="w-3/12 flex justify-center">
              <span className="text-cendiatra-verde-2 font-bold text-center text-2xl">
                {aplicarFormatoMoneda(totalTabla)}
              </span>
            </div> */}
            {/* CODIGO COMENTADO POR CAMBIO EN RETENCIONES */}
            <div className="w-full flex justify-center items-center my-5">
              <span className=" text-cendiatra-gris-2 font-bold text-start text-lg">
                Cendiatra no asume la responsabilidad de errores en la
                información proporcionada por el cliente.
              </span>
            </div>
          </div>
        )}
      </div>
      <div className="w-full flex justify-center items-center mt-1">
        <div className=" flex justify-center items-center pointer-events-auto">
          <button
            className={`opacity-70 group relative w-28 h-10 flex justify-center py-2 px-4 border border-transparent text-lg rounded-md text-cendiatra-verde-2 bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cendiatra font-bold m-2`}
            type="button"
            onClick={funcionRegresar}
          >
            {' '}
            <u>A</u>trás
          </button>

          <BotonSimple
            texto={'Pagar'}
            estilosBoton={clsx(
              'h-40px w-28 p-1.5 rounded-lg bg-cover bg-no-repeat bg-center text-white font-bold text-14px',
              {
                'bg-cendiatra':
                  Object.keys(errors).length === 0 &&
                  !alertaICA &&
                  aplicaRetenciones,
                'bg-cendiatra-gris-2 pointer-events-none': !(
                  Object.keys(errors).length === 0 &&
                  !alertaICA &&
                  aplicaRetenciones
                ),
              }
            )}
            funcion={() =>
              manejarGuardar(
                datosTransaccion,
                datosServicio,
                datosTiquetera,
                datosSede,
                valoresTabla,
                municipio,
                totalTabla
              )
            }
            deshabilitado={
              (Object.keys(errors).length !== 0 || alertaICA) &&
              !aplicaRetenciones
            }
          />
        </div>
      </div>
    </>
  )
}

export default OtrosServiciosRecargarCuentaServicios
